import { LayerObjectHelpers } from './layer-object-helpers.js';
import { LayerObjectFactory } from './layer-object-factory.js';


export function Layer (pEditor)
{
  this.helpers = new LayerObjectHelpers(pEditor, this);

  pEditor.pThis.addHandler('starting', () => this.objectFactory = new LayerObjectFactory(pEditor, this));

  let coAbsElementZIndex = 3,
      currentAbsElement;
  
  
  this.openLayerDropdown = pButton =>
  {
    pEditor.pDropdown = pButton.getDropdown();

    if (!pEditor.pDropdown)
    {
      return false;
    }

    if (pEditor.pDropdown.getState())
    {
      pEditor.closeDropdown(pButton);
    }
    else
    {
      pEditor.pDropdown.getWindow().isLayerDropdown = true;
      pEditor.pDropdown.getWindow().isLayerSelected = queryStatePositionAbsolute(pButton);
      pEditor.openDropdown(pButton, pEditor.pDropdown, 'layerDropdownHandler');
    }
  };


  const layerDropdownHandler = pButton =>
  {
    var pParameters, tCommand;

    pEditor.pDropdown = pButton.getDropdown();

    if (pEditor.pDropdown)
    {
      pParameters = pEditor.pDropdown.getReturnedParameters();

      if (pParameters && pParameters.selectedStyleId)
      {
        tCommand = pParameters.selectedStyleId;
      }
    }

    pEditor.closeDropdown(pButton);

    if (tCommand)
    {
      pEditor.pThis.execCommand(pButton, tCommand);
    }
  };


  const queryStatePositionAbsolute = () =>
  {
    if (this.helpers.isRangeElementPositionAbsolute())
    {
      this.objectFactory.fixAbsGecko();
      return true;
    }

    return false;
  };


  this.setPositionAbsolute = () =>
  {
    var currentSelection = pEditor.range.selection.getCurrent(),
        currentRange = pEditor.range.getCurrent(),
        currentElement = this.helpers.isRangeElementPositionAbsolute(),
        parentCurrentElement,
        currentElementCoords,
        coords,
        left,
        top,
        newAbsElement,
        isCollapsed,
        iFrameDocBodyOffsetWidth,
        currentElementOffsetWidth,
        isContinue = false;

    pEditor.undoRedo.isStopSaveUndo = true;

    if (currentElement)
    {
      if (BEditor.browser.isIE)
      {
        if (currentElement.parentNode)
        {
          currentElement.parentNode.removeChild(currentElement);
          pEditor.range.setCursorPoint(pEditor.iFrameDoc.body, true);
        }
      }
      else
      {
        this.objectFactory.deleteAbsElement(currentElement);
      }
    }
    else
    {
      this.helpers.removeEmptyAbsElements();

      if (BEditor.browser.isIE)
      {
        if ((currentSelection.type.toUpperCase() == 'CONTROL' && currentRange.length == 1 && currentRange.item(0).nodeName.toUpperCase() == 'IMG') || pEditor.image.currentImage)
        {
          currentElement = (currentRange && currentRange.item) ? currentRange.item(0) : pEditor.image.currentImage;
          currentElementCoords = BEditor.dimensions.getElementXY(currentElement);

          iFrameDocBodyOffsetWidth = pEditor.iFrameDoc.body.offsetWidth;
          currentElementOffsetWidth = currentElement.offsetWidth;
          left = (currentElementCoords.left + 30 + currentElementOffsetWidth < iFrameDocBodyOffsetWidth) ? currentElementCoords.left + 30 : iFrameDocBodyOffsetWidth - currentElementOffsetWidth;
          top = (currentElementCoords.top - 30 > 0) ? currentElementCoords.top - 30 : 0;
          newAbsElement = currentElement.cloneNode(true);
          newAbsElement.setAttribute('style', 'position: absolute; left: ' + left + 'px; top: ' + top + 'px; z-index: ' + (coAbsElementZIndex++) + ';');
          pEditor.iFrameDoc.body.appendChild(newAbsElement);
          pEditor.range.selection.selectControlRangeElement(newAbsElement);
        }
        else if (currentSelection.type.toUpperCase() != 'CONTROL')
        {
          currentElement = currentRange.parentElement();
          coords = getNewAbsElementCoords(currentElement);
          left = coords.left;
          top = coords.top;

          newAbsElement = pEditor.iFrameDoc.createElement('DIV');
          newAbsElement.setAttribute('data-autoabs', 'true');
          newAbsElement.setAttribute('style', 'position: absolute; left: ' + left + 'px; top: ' + top + 'px; z-index: ' + (coAbsElementZIndex++) + '; overflow: hidden;');
          newAbsElement.innerHTML = (currentRange.htmlText.replace(/\s*(?:<p(?:\s.*?)?>\s*(?:&nbsp;)?\s*<\/p>|\s*&nbsp;\s*|\s+)\s*/i, '') === '' ? '&nbsp;&nbsp;N&nbsp;e&nbsp;w<br>&nbsp;<br>&nbsp;l&nbsp;a&nbsp;y&nbsp;e&nbsp;r&nbsp;' : currentRange.htmlText);
          pEditor.iFrameDoc.body.appendChild(newAbsElement);
          pEditor.range.selection.selectControlRangeElement(newAbsElement);
        }
      }
      else
      {
        isCollapsed = currentRange.collapsed;

        if (currentRange.startContainer === currentRange.endContainer && currentRange.endOffset - currentRange.startOffset < 2 && !isCollapsed)
        {
          parentCurrentElement = currentRange.startContainer;

          if (parentCurrentElement.hasChildNodes())
          {
            currentElement = parentCurrentElement.childNodes[currentRange.startOffset];

            if (currentElement)
            {
              if (currentElement.nodeName == 'IMG')
            {
              currentElementCoords = BEditor.dimensions.getElementXY(currentElement);
              iFrameDocBodyOffsetWidth = pEditor.iFrameDoc.body.offsetWidth;
              left = (currentElementCoords.left + 30 < iFrameDocBodyOffsetWidth) ? currentElementCoords.left + 30 : iFrameDocBodyOffsetWidth - 30;
              top = (currentElementCoords.top - 30 > 0) ? currentElementCoords.top - 30 : 0;
              newAbsElement = currentElement.cloneNode(true);
              newAbsElement.setAttribute('style', 'position: absolute; left: ' + left + 'px; top: ' + top + 'px; z-index: ' + (coAbsElementZIndex++) + ';');
              newAbsElement.setAttribute('data-initwidth', currentElement.offsetWidth);
              newAbsElement.setAttribute('data-initheight', currentElement.offsetHeight);
              pEditor.iFrameDoc.body.appendChild(newAbsElement);
            }
              else if (currentElement.nodeType === 3)
              {
                isContinue = true;
              }
            }
          }
        }
        else
        {
          isContinue = true;
        }

        if (isContinue)
        {
          currentElement = currentRange.startContainer;
          coords = getNewAbsElementCoords(currentElement);
          left = coords.left;
          top = coords.top;

          newAbsElement = pEditor.iFrameDoc.createElement('DIV');
          newAbsElement.setAttribute('data-autoabs', 'true');
          newAbsElement.setAttribute('style', 'position: absolute; left: ' + left + 'px; top: ' + top + 'px; z-index: ' + (coAbsElementZIndex++) + '; overflow: hidden;');
          pEditor.iFrameDoc.body.appendChild(newAbsElement);

          if (isCollapsed)
          {
            newAbsElement.innerHTML = '&nbsp;&nbsp;N&nbsp;e&nbsp;w<br>&nbsp;<br>&nbsp;l&nbsp;a&nbsp;y&nbsp;e&nbsp;r&nbsp;';
          }
          else
          {
            newAbsElement.appendChild(currentRange.cloneContents());
          }

          currentSelection.removeAllRanges();
          currentRange = pEditor.iFrameDoc.createRange();
          currentRange.selectNodeContents(newAbsElement);
          currentRange.collapse(isCollapsed);
          currentSelection.addRange(currentRange);
        }
      }

      this.objectFactory.fixAbsElement(newAbsElement, true);
    }

    pEditor.undoRedo.saveUndoDo();
    pEditor.undoRedo.isStopSaveUndo = false;
  };


  const getNewAbsElementCoords = currentElement =>
  {
    var currentElementCoords,
        left,
        top,
        iFrameDocBodyOffsetWidth;

    if (currentElement)
    {
      while (currentElement && currentElement.nodeType !== 1)
      {
        currentElement = currentElement.parentNode;
      }

      if (currentElement)
      {
        currentElementCoords = BEditor.dimensions.getElementXY(currentElement);

        if (pEditor.mouse.mouseDownLastCoords.X != null && pEditor.mouse.mouseDownLastCoords.Y != null)
        {
          left = pEditor.mouse.mouseDownLastCoords.X;

          if (pEditor.mouse.mouseDownLastCoords.Y < currentElementCoords.top)
          {
            top = currentElementCoords.top;
          }
          else if (pEditor.mouse.mouseDownLastCoords.Y > currentElementCoords.bottom)
          {
            top = currentElementCoords.bottom;
          }
          else
          {
            top = pEditor.mouse.mouseDownLastCoords.Y;
          }
        }
        else
        {
          left = currentElementCoords.left;
          top = currentElementCoords.top;
        }

        iFrameDocBodyOffsetWidth = pEditor.iFrameDoc.body.offsetWidth;
        left = (left + 30 < iFrameDocBodyOffsetWidth) ? left + 30 : iFrameDocBodyOffsetWidth - 30;
        top = (top - 30 > 0) ? top - 30 : 0;
      }
      else
      {
        left = 0;
        top = 0;
      }
    }
    else
    {
      left = 0;
      top = 0;
    }

    return {'left': left, 'top': top };
  };


  this.setZIndex = (pButton, command) =>
  {
    var i,
        minMaxZIndex,
        absElement = this.helpers.isRangeElementPositionAbsolute(),
        elements,
        elementZIndex;

    if (absElement)
    {
      minMaxZIndex = this.helpers.getMinMaxZIndex();

      if (command === 'Forward')
      {
        absElement.style.zIndex = minMaxZIndex.maxZ + 1;
        coAbsElementZIndex = minMaxZIndex.maxZ + 2;
      }
      else
      {
        if (minMaxZIndex.minZ === 0)
        {
          elements = pEditor.iFrameDoc.body.getElementsByTagName('*');

          for (i = 0; i < elements.length; i++)
          {
            if ((elements[i].nodeName.toUpperCase() === 'IMG' || elements[i].nodeName.toUpperCase() === 'DIV') && pEditor.$Style(elements[i], 'position') === 'absolute')
            {
              elementZIndex = pEditor.$StyleStrictInt(elements[i], 'zIndex');

              if (elementZIndex !== null)
              {
                elements[i].style.zIndex = elementZIndex + 100;
              }
            }
          }

          minMaxZIndex = this.helpers.setAbsElementZIndexCounter();
        }

        absElement.style.zIndex = minMaxZIndex.minZ - 1;
      }

      if (BEditor.browser.isIE)
      {
        pEditor.range.selection.selectControlRangeElement(absElement);
      }
    }
  };


  this.alignLayer = (pButton, command) =>
  {
    var width = pEditor.iFrameDoc.body.clientWidth,
        height = pEditor.iFrameDoc.body.clientHeight,
        absElement = this.helpers.isRangeElementPositionAbsolute();

    if (absElement && width && height)
    {
      if (pEditor.image.controls)
      {
        pEditor.image.controls.hideControls();
      }

      switch (command)
      {
        case 'Left':
          absElement.style.left = '0px';
          break;

        case 'Center':
          absElement.style.left = Math.floor((width - absElement.offsetWidth) / 2) + 'px';
          break;

        case 'Right':
          absElement.style.left = (width - absElement.offsetWidth) + 'px';
          break;

        case 'Top':
          absElement.style.top = '0px';
          break;

        case 'Middle':
          absElement.style.top = Math.floor((height - absElement.offsetHeight) / 2) + 'px';
          break;

        case 'Bottom':
          absElement.style.top = (height - absElement.offsetHeight) + 'px';
          break;
      }

      if (BEditor.browser.isIE)
      {
        pEditor.range.selection.selectControlRangeElement(absElement);
      }
    }
  };


  this.layerDropdownHandler = layerDropdownHandler;
  this.queryStatePositionAbsolute = queryStatePositionAbsolute;

  Object.defineProperty(this, 'currentAbsElement', { get: () => currentAbsElement, set: v => { currentAbsElement = v }});
  Object.defineProperty(this, 'coAbsElementZIndex', { get: () => coAbsElementZIndex, set: v => { coAbsElementZIndex = v }});
}